import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { MarginSummaryResponsePayload } from '@Types'
import { MARGIN_SUMMARY_API } from './constants'
import axios from 'axios'

const getBaseUrl = (accountNumber: string, processDate?: string) => {
  if (processDate) {
    return `${getAppConfigSetting('apiUrl')}${MARGIN_SUMMARY_API}/${accountNumber}/${processDate}`
  }
  return `${getAppConfigSetting('apiUrl')}${MARGIN_SUMMARY_API}/${accountNumber}`
}

export default function useGetMarginSummary(accountNumber: string, processDate?: string) {
  const callMarginSummary = async () => {
    const apiUrl = getBaseUrl(accountNumber, processDate)
    const result = await axios.get(apiUrl, {
      withCredentials: true
    })
    return result.data as MarginSummaryResponsePayload
  }

  return useQuery(['margin-summary', accountNumber], callMarginSummary, { enabled: !!accountNumber })
}
